import $http from './http'
import config from './config'

export default {
  name: 'flight',
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  CheckRepeatOrder(data) {
    return $http.post(this.getUrl('/FlightOrder/CheckRepeatOrder'), data, {
        failTips: false
    });
  },
  getCreateOrder(data) {
    // return $http.post(this.getUrl(`/FlightOrder/CreateOrder`), data);
    return $http.post(this.getUrl(`/FlightOrder/CreateOrderByProduct`), data);
  },
  OrderDetails(UniqueID) {
    return $http.get(this.getUrl(`/FlightOrder/OrderDetails?UniqueID=${UniqueID}`));
  },
  OrderCancel(id) {
    return $http.get(this.getUrl(`/FlightOrder/OrderCancel?UniqueID=${id}`));
  },
  RefundJudge(UniqueID) {
    return $http.get(this.getUrl(`/FlightOrder/RefundJudge?UniqueID=${UniqueID}`));
  },
  CreateAmend(amend) {
    return $http.post(this.getUrl(`/FlightOrder/CreateAmend`), amend)
  },
  OrderChange(data) {
    return $http.post(this.getUrl(`/FlightOrder/FlightOrderChange`), data);
  },
  OrderSubmit(UniqueID) {
    return $http.get(this.getUrl(`/FlightOrder/OrderSubmit/${UniqueID}`));
  },
  UpdateOrderStatus(id) {
    return $http.get(this.getUrl(`/FlightOrder/UpdateOrderStatus?UniqueID=${id}`));
  },
  OrderRefund(data) {
    return $http.post(this.getUrl('/FlightOrder/OrderRefund'), data);
  },
  getReplenishOrderInfomation(data) {
    return $http.post(this.getUrl('/FlightOrder/ReplenishOrderInfomation'), data);
  },
  CreateOrderByPreference(data) {
    return $http.post(this.getUrl('/FlightOrder/CreateOrderByPreference'), data);
  },
  SearchOrders(id) {
    return $http.get(this.getUrl(`/FlightOrder/SearchOrders?UniqueID=${id}`));
  },
  OrderRefundCancel(id) {
    return $http.get(this.getUrl(`/FlightOrder/OrderRefundCancel?UniqueID=${id}`));
  },
}



// WEBPACK FOOTER //
// ./src/apis/flightApis.js